<template>
  <div class="about-page">
    <section class="about-hero">
      <h1>以技术服务为核心，构建多元经营能力</h1>
      <p class="desc">
        我们以技术服务、技术开发与技术咨询为基础，延伸物联网研发、人工智能硬件、
        电子产品、珠宝首饰与日用百货等多元经营板块，并配套国内贸易代理、互联网销售、
        进出口代理与国际货物运输代理能力，为客户提供稳定可靠的合作支持。
      </p>
    </section>

    <div class="content-body">
      <section class="about-grid">
        <article class="card">
          <h3>技术服务</h3>
          <p>提供技术开发、技术咨询、技术交流、技术转让与技术推广，配套网络与信息技术咨询服务。</p>
        </article>
        <article class="card">
          <h3>产品与研发</h3>
          <p>聚焦物联网技术研发与技术服务、人工智能硬件、商用密码产品及其他电子器件制造与销售。</p>
        </article>
        <article class="card">
          <h3>贸易与流通</h3>
          <p>国内贸易代理、互联网销售、货物与技术进出口、进出口代理及国际货物运输代理一体化协同。</p>
        </article>
      </section>

      <section class="timeline">
        <h2>标准业务执行流程</h2>
        <div class="steps">
          <div class="step">
            <h4>01 / 需求沟通</h4>
            <p>明确技术需求、产品品类与交付目标，输出匹配的方案与报价路径。</p>
          </div>
          <div class="step">
            <h4>02 / 方案交付</h4>
            <p>推进技术开发、产品供应与渠道对接，按节点完成交付与验收。</p>
          </div>
          <div class="step">
            <h4>03 / 履约与复盘</h4>
            <p>跟进物流履约、售后支持与合作复盘，持续优化后续合作效率。</p>
          </div>
        </div>
      </section>

      <section class="metrics">
        <div class="metric">
          <p class="num">多品类</p>
          <p class="txt">涵盖技术、智能硬件、珠宝工艺与日用消费等经营方向</p>
        </div>
        <div class="metric">
          <p class="num">全链路</p>
          <p class="txt">从研发生产到贸易代理与物流履约的闭环服务</p>
        </div>
        <div class="metric">
          <p class="num">合规经营</p>
          <p class="txt">在适用法律与监管要求范围内依法开展业务</p>
        </div>
      </section>

      <section class="company">
        <h2>企业信息</h2>
        <ul class="company-list">
          <li>
            <span class="k">企业法定全称</span>
            <span class="v">ZOCEL LLC（注册地语言）</span>
          </li>
          <li>
            <span class="k">Legal Name</span>
            <span class="v">ZOCEL LLC</span>
          </li>
          <li>
            <span class="k">企业注册号</span>
            <span class="v">1625145.06</span>
          </li>
          <li>
            <span class="k">企业注册地址</span>
            <span class="v">1305 Griffin St Unit A, London, KY 40741</span>
          </li>
          <li>
            <span class="k">Jurisdiction</span>
            <span class="v">Kentucky, United States</span>
          </li>
        </ul>
      </section>

      <section class="company">
        <h2>业务范围 / Business Activities</h2>
        <div class="scope-block">
          <h3 class="scope-title">技术服务与咨询 · Technology Services &amp; Consulting</h3>
          <p class="scope-text">
            Technical services, technology development, technical consulting, technical exchange, technology transfer and technology promotion; network technology services; information technology consulting services.
          </p>
          <p class="scope-text scope-text-cn">
            技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；网络技术服务；信息技术咨询服务。
          </p>
        </div>
        <div class="scope-block">
          <h3 class="scope-title">物联网与人工智能 · IoT &amp; Artificial Intelligence</h3>
          <p class="scope-text">
            IoT technology research &amp; development and IoT technical services; AI hardware sales; electronic products sales; other electronic device manufacturing; security and commercial cryptography products development and sales.
          </p>
          <p class="scope-text scope-text-cn">
            物联网技术研发、物联网技术服务；人工智能硬件销售；电子产品销售；其他电子器件制造；商用密码产品研发、生产与销售。
          </p>
        </div>
        <div class="scope-block">
          <h3 class="scope-title">零售与电商 · Retail &amp; E-commerce</h3>
          <p class="scope-text">
            Jewelry manufacturing and retail; retail of arts, crafts and collectibles (excluding ivory and its products); gifts and flowers; daily necessities; apparel and accessories; outdoor products; lighting fixtures; hardware products; automotive parts; computer hardware, software and peripherals; communication equipment; prepackaged food sales and online food sales; internet sales of goods.
          </p>
          <p class="scope-text scope-text-cn">
            珠宝首饰制造与零售；工艺美术品及收藏品零售（象牙及其制品除外）；礼品花卉销售；日用百货销售；服装服饰零售；户外用品销售；灯具销售；五金产品零售；汽车零配件零售；计算机软硬件及辅助设备零售；通讯设备销售；预包装食品销售与食品互联网销售；互联网销售。
          </p>
        </div>
        <div class="scope-block">
          <h3 class="scope-title">贸易与物流 · Trade &amp; Logistics</h3>
          <p class="scope-text">
            Domestic trade agency; import and export of goods; import and export of technology; import and export agency; international freight forwarding; road freight transportation (excluding hazardous goods).
          </p>
          <p class="scope-text scope-text-cn">
            国内贸易代理；货物进出口；技术进出口；进出口代理；国际货物运输代理；道路货物运输（不含危险货物）。
          </p>
        </div>
        <p class="scope-note">
          ZOCEL LLC 在适用法律与监管要求的范围内开展上述业务；涉及许可、资质或审批的项目，将在取得相应批准或许可后依法经营。
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutView"
};
</script>

<style scoped>
.about-page {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px 0;
  color: #eff5f8;
}

.about-hero {
  margin-bottom: 48px;
  text-align: center;
}


h1 {
  margin: 12px 0 16px;
  font-size: 32px;
  line-height: 1.3;
}

.desc {
  margin: 0 auto;
  max-width: 640px;
  color: #a2a4ad;
  line-height: 1.8;
  font-size: 15px;
}

.content-body {
  display: flex;
  flex-direction: column;
  gap: 48px;
}

h2 {
  margin: 0 0 24px;
  font-size: 22px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 12px;
}

.about-grid {
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(3, 1fr);
}

.card h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: var(--accent);
}

.card p, .step p {
  margin: 0;
  line-height: 1.7;
  color: #a2a4ad;
  font-size: 14px;
}

.steps {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.step h4 {
  margin: 0 0 8px;
  font-size: 16px;
}

.metrics {
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 32px;
}

.metric {
  text-align: center;
}

.num {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 700;
  color: var(--accent-soft);
}

.txt {
  margin: 0;
  color: #a2a4ad;
  line-height: 1.5;
  font-size: 14px;
}

.company-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 12px;
}

.company-list li {
  display: grid;
  grid-template-columns: 160px 1fr;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.company-list .k {
  color: var(--accent-soft);
  font-size: 13px;
  font-weight: 700;
}

.company-list .v {
  color: #eff5f8;
  font-size: 14px;
  line-height: 1.6;
  word-break: break-word;
}

.scope-block {
  padding: 14px 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.scope-block + .scope-block {
  margin-top: 12px;
}

.scope-title {
  margin: 0 0 8px;
  font-size: 15px;
  color: var(--accent);
}

.scope-text {
  margin: 0;
  color: #a2a4ad;
  font-size: 14px;
  line-height: 1.9;
}

.scope-text + .scope-text {
  margin-top: 8px;
}

.scope-text-cn {
  color: rgba(154, 176, 188, 0.72);
  font-size: 13px;
}

.scope-note {
  margin: 14px 0 0;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(244, 67, 108, 0.1);
  border: 1px solid rgba(244, 67, 108, 0.24);
  color: #eff5f8;
  font-size: 13px;
  line-height: 1.8;
}

@media (max-width: 640px) {
  .company-list li {
    grid-template-columns: 1fr;
    gap: 4px;
  }
}

@media (max-width: 768px) {
  .about-grid, .metrics {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}
</style>
